import {
  SettingRow,
  SettingWrapper,
} from '@affine/component/setting-components';
import { AuthService, ServerService } from '@affine/core/modules/cloud';
import { useI18n } from '@affine/i18n';
import { ArrowRightSmallIcon } from '@blocksuite/icons/rc';
import { cssVarV2 } from '@streamlain/theme/v2';
import { useLiveData, useService } from '@toeverything/infra';
import { useCallback, useState } from 'react';

import type { SettingState } from '../types';
import { AccountDeletionDialog } from './account-deletion-dialog';

// sl-zvjz: Setting-row trigger only. The dialog itself owns preview-load,
// HARD-BLOCK rendering, multi-step flow, type-confirm and submit handling.
export const DeleteAccount = ({
  onChangeSettingState,
}: {
  onChangeSettingState?: (settingState: SettingState) => void;
}) => {
  const t = useI18n();
  const serverService = useService(ServerService);
  const authService = useService(AuthService);
  const account = useLiveData(authService.session.account$);

  const [open, setOpen] = useState(false);
  const openDialog = useCallback(() => setOpen(true), []);
  const openWorkspaceBackup = useCallback(() => {
    setOpen(false);
    onChangeSettingState?.({ activeTab: 'workspace:storage' });
  }, [onChangeSettingState]);

  return (
    <SettingWrapper>
      <SettingRow
        name={
          <span style={{ color: cssVarV2('status/error') }}>
            {t['com.streamlain.setting.account.delete-from-server']({
              server: serverService.server.config$.value.serverName,
            })}
          </span>
        }
        desc={t['com.streamlain.setting.account.delete.message']()}
        style={{ cursor: 'pointer' }}
        onClick={openDialog}
        data-testid="delete-account-button"
      >
        <ArrowRightSmallIcon />
      </SettingRow>
      {account?.email ? (
        <AccountDeletionDialog
          open={open}
          email={account.email}
          onOpenChange={setOpen}
          onOpenWorkspaceBackup={openWorkspaceBackup}
        />
      ) : null}
    </SettingWrapper>
  );
};
